export default __webpack_public_path__ + "static/media/pdf.03ea697c.png";